export const ACCOUNT_PATHNAME = '/account'
export const ERROR_PATHNAME = 'sorry'
export const HOME_PATHNAME = '/'
export const NOT_FOUND = '/not-found'
export const ORDER_CONFIRMATION_PATHNAME = '/orders/:orderId/order-confirmation'
export const ORDER_HISTORY_PATHNAME = '/my-orders'
export const ORDER_PATHNAME = '/orders/:orderId'
export const ORDER_REVIEW_PATHNAME = '/orders/:orderId/review'
export const ORDER_CHECKOUT_PATHNAME = '/orders/:orderId/checkout'
export const PARTS_LIBRARY_PATHNAME = '/my-parts'
export const ORDER_PAYMENT_SUCCESS = '/payments/:orderId/success'
export const DOCUMENTS_PATHNAME = '/documents/:orderId/:documentType/:action?'
export const LOGIN_PATHNAME = '/login'
export const LOGOUT_PATHNAME = '/logout'
